export enum EnumTitlePosition {
	IN = 'in',
	BELOW = 'below',
}
